import PropTypes from 'prop-types'
import React from 'react'

import { fullName } from 'src/services/user_helpers'

import GuestListRowContainer from './GuestListRowContainer'

export default function HostRow (props) {
  const { customHostName, invitations, user } = props

  const rows = invitations.map((invitation) => {
    return (
      <GuestListRowContainer
        key={invitation.id}
        invitation={invitation}
        guestName={customHostName}
      />
    )
  })

  return (
    <div>
      {rows.length > 0 ? (
        rows
      ) : (
        <GuestListRowContainer
          guestName={customHostName || fullName(user)}
          user={user}
        />
      )}
    </div>
  )
}

HostRow.propTypes = {
  customHostName: PropTypes.string,
  invitations: PropTypes.array,
  user: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/guest_list/HostRow.jsx